import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column } from 'seagull/components/Layout';
import { Typography } from 'seagull/components/Typography';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useTasksJobs } from '../../hooks/useTasksJobs';
import { TasksSection } from './TasksSection';
export const GetTasksSectionsTID = (parentTestId)=>getTestIds(parentTestId);
function partition(tasks) {
    const inProgress = [];
    const failed = [];
    const completed = [];
    for (const task of tasks){
        if (task.status === 'failed') failed.push(task);
        else if (task.status === 'ready') completed.push(task);
        else inProgress.push(task);
    }
    return {
        inProgress,
        failed,
        completed
    };
}
export const TasksSections = (param)=>{
    let { renderTask, testId } = param;
    const { t: tasksDrawerTexts } = useLocaleKeys('tasksDrawer');
    const { tasks } = useTasksJobs();
    const { TasksSectionsTID } = useMemo(()=>GetTasksSectionsTID(testId), [
        testId
    ]);
    const visibleTasks = useMemo(()=>tasks.filter((t)=>!t.cancelling), [
        tasks
    ]);
    const buckets = useMemo(()=>partition(visibleTasks), [
        visibleTasks
    ]);
    if (visibleTasks.length === 0) {
        return /*#__PURE__*/ _jsxs(Column, {
            gap: 8,
            alignItems: "center",
            padding: 24,
            testId: TasksSectionsTID.Root(),
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph2",
                    weight: "bold",
                    testId: TasksSectionsTID.EmptyTitle(),
                    children: tasksDrawerTexts.empty.title()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    skin: "secondary",
                    testId: TasksSectionsTID.EmptyBody(),
                    children: tasksDrawerTexts.empty.body()
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsxs(Column, {
        gap: 16,
        padding: "16px 24px 24px",
        testId: TasksSectionsTID.Root(),
        children: [
            /*#__PURE__*/ _jsx(TasksSection, {
                title: tasksDrawerTexts.sections.inProgress({
                    count: buckets.inProgress.length
                }),
                tasks: buckets.inProgress,
                renderTask: renderTask,
                testId: TasksSectionsTID.Section.InProgress()
            }),
            /*#__PURE__*/ _jsx(TasksSection, {
                title: tasksDrawerTexts.sections.failed({
                    count: buckets.failed.length
                }),
                tasks: buckets.failed,
                renderTask: renderTask,
                testId: TasksSectionsTID.Section.Failed()
            }),
            /*#__PURE__*/ _jsx(TasksSection, {
                title: tasksDrawerTexts.sections.completed({
                    count: buckets.completed.length
                }),
                tasks: buckets.completed,
                renderTask: renderTask,
                testId: TasksSectionsTID.Section.Completed()
            })
        ]
    });
};
